import { BLEConnectionManager } from './types'
import { BleConnectionStatus, BleProviderEventTypes } from './constants'
import BleProvider, { logger } from './index'
import BleConnection from './connection'

const BleConnectionManager: BLEConnectionManager = {
  get provider() {
    return BleProvider
  },
  connections: {},

  async init() {
    if (!this.isSupport()) {
      return
    }

    logger('[BLE_CONNECTION_MANAGER] EXECUTE_ACTIVATE_CONNECTION')

    this.connections = {}

    this.provider.init()

    this.provider.addListener(
      BleProviderEventTypes.DEVICE_ADDED,
      this.handleDeviceAdded.bind(this)
    )
  },

  getProvider() {
    return this.provider
  },

  isSupport() {
    return this.provider.isSupport()
  },

  activateConnection(address: string, params = {}, manual = false) {
    logger(
      '[BLE_CONNECTION_MANAGER] EXECUTE_ACTIVATE_CONNECTION',
      address,
      params
    )
    return this.connections[address].run(params, manual)
  },

  activateAllConnections() {
    const connections = this.connections

    return Promise.all(
      Object.keys(connections).map(address => this.activateConnection(address))
    )
  },

  disconnect(address) {
    logger('[BLE_CONNECTION_MANAGER] EXECUTE_DISCONNECT', address)
    return this.connections[address].stop()
  },

  disconnectAll() {
    const connections = this.connections

    return Promise.all(
      Object.keys(connections)
        .filter(address => connections[address].isRunning())
        .map(address => this.disconnect(address))
    )
  },

  async terminate(address) {
    const connections = this.connections
    try {
      await this.disconnect(address)
    } catch (error) {
      connections[address].setStatus(BleConnectionStatus.DISCONNECTED)
    }
  },

  async terminateAll() {
    const connections = this.connections
    await Promise.all(
      Object.keys(connections)
        .filter(address => connections[address].isRunning())
        .map(address => this.terminate(address))
    )
  },

  setDevice(device) {
    this.connections[device.address] = new BleConnection(
      device,
      device.connected
        ? BleConnectionStatus.CONNECTED
        : BleConnectionStatus.DISCONNECTED
    )
  },

  handleDeviceAdded(device) {
    if (!this.connections[device.address]) {
      this.connections[device.address] = new BleConnection(
        device,
        BleConnectionStatus.DISCONNECTED
      )
    }
  },

  setProcessing(address, processing) {
    this.connections[address].setProcessing(processing)
  }
}

export default BleConnectionManager
